<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-入库管理-添加
    -->
    <el-dialog
    title="添加入库"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="80%" 
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">基本信息</div>
     
        <el-form-item label="流程：" >
          <el-steps :active="activeStep" align-left>
              <el-step title="从哪入库" description="选择厂家"></el-step>
              <el-step title="" description="选择商品"></el-step>
              <el-step title="入库到哪" description="选择平台库位"></el-step>
              <el-step title="" description="入库"></el-step>
          </el-steps>
      </el-form-item>
      <el-form-item label="入库类型：" >
          <el-radio-group v-model="form.type">
            <!-- <el-radio :label="0">市场采购</el-radio> -->
            <el-radio :label="1">供应商采购</el-radio>
            <!-- <el-radio :label="2">售后入库</el-radio> -->
          </el-radio-group>
        </el-form-item>

        <Supply :form="form" v-if="form.type == 1" @closeDialogs="closeDialogs"></Supply>

        <div class="common-form" v-if="form.supply_id > 0">入库清单</div>   
        <el-button icon="el-icon-plus" @click="changeProduct(form.product)" v-if="form.supply_id > 0">选择商品</el-button>
        
        <div class="d-s-c pt16 max-w460 active-all-set" v-if="form.supply_id > 0">
        <div style="width: 60px;">批量设置：</div>
        <div class="flex-1"><el-input v-model="set_num" type="number" min="0" placeholder="数量"></el-input></div>
          
        <div >
                
                <el-select v-model="warehouse_kw_id">
                    <template v-for="item in warehouse" >
                      <el-option
                        value="0"
                          :key="item.warehouse_id"
                        :label="item.name"
                         prop="warehouse_kw_id"

                      ></el-option>
                      <template v-if="item.warehousekw !== undefined" v-for="itemA in item.warehousekw">
                        <el-option
                          :value="itemA.warehouse_kw_id"
                          :key="itemA.warehouse_kw_id"
                          :label="itemA.name"
                          style="padding-left: 30px"
                        ></el-option>
                    
                      </template>
                    </template>
                </el-select>
         
            </div>
        <div class="ml10"><el-button @click="allApply">应用</el-button></div>
      </div>
        
        
        <el-table  v-if="form.supply_id > 0" size="small" :data="form.product"   border 
        style="overflow-y: auto;  width: 100%;height:400px;" 
        v-loading="loading">
          <el-table-column prop="product_name" label="商品"></el-table-column>
          <el-table-column prop="spec_value" label="规格"></el-table-column>
          <el-table-column prop="unit" label="计量单位"></el-table-column>
          <el-table-column prop="set_num" label="数量">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.set_num"
                @input="updateAmount(scope.row)"
                placeholder="请输入数量"
                type="number"
              ></el-input>

            </template>

          </el-table-column>
          <el-table-column prop="product_price" label="单价">
            <template slot-scope="scope">
            
              <el-input
                v-model="scope.row.product_price"
                @input="updateAmount(scope.row)"
                placeholder="请输入单价"
                type="number"
              ></el-input>
            </template>

          </el-table-column>
          <el-table-column prop="amount" label="金额">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.amount"
                @input="updateUnitPrice(scope.row)"
                placeholder="请输入金额"
                type="number"
              ></el-input>
            </template>

          </el-table-column>
          <el-table-column prop="rk.price" label="最近入库单价"></el-table-column>
          <el-table-column prop="warehouse_kw_id" label="选择库区">
            <template slot-scope="scope">
                <div>
                
                    <el-select v-model="scope.row.warehouse_kw_id">
                        <template v-for="item in warehouse" >
                          <el-option
                            value="0"
                              :key="item.warehouse_id"
                            :label="item.name"
                             prop="warehouse_kw_id"

                          ></el-option>
                          <template v-if="item.warehousekw !== undefined" v-for="itemA in item.warehousekw">
                            <el-option
                              :value="itemA.warehouse_kw_id"
                              :key="itemA.warehouse_kw_id"
                              :label="itemA.name"
                              style="padding-left: 30px"
                            ></el-option>
                        
                          </template>
                        </template>
                    </el-select>
             
                </div>
             
              </template>

          </el-table-column>
          <el-table-column prop="rk.rk_text" label="入库状态">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="del(scope.$index)" size="mini">删除</el-button>
            </template>
          </el-table-column>


          <!-- 自定义插入一行 -->
          <template v-slot:append  v-if="form.product">
            
            <div style="float: right;">
              <tr class="custom-footer" style="border: 1px solid red;height: 50px;">
              <!-- 合并列 --> 
             
                <td style=" width: 100px;float: right;line-height: 50px; height: 50px; text-align: center; background-color: #f5f5f5;">
                  <el-input v-model="form.actualAmount" placeholder="请输入" style="width: 100px;"></el-input>
                </td>
                <td style="width: 100px;float: right;line-height: 50px; text-align: center; background-color: #f5f5f5;">
                  实付款
                </td>
                <td style="width: 100px;float: right;line-height: 50px; text-align: center; background-color: #f5f5f5;">
                  {{ form.totalAmount }}
                </td>
                <td  style="width: 100px;float: right;line-height: 50px; text-align: center; font-weight: bold; background-color: #f5f5f5;">
                  总计
                </td>
              <div style="clear: both;"></div>
            </tr>
            </div>
            
       
          </template>
        </el-table>


        <div class="common-form">其它费用</div>   

            <el-select v-model="selectType" placeholder="支出类型">
              <el-option label="采购支出" value="1"></el-option>
              <el-option label="杂费支出" value="2"></el-option>

            </el-select>
            <el-button icon="el-icon-plus" @click="addZf(selectType)">添加</el-button>
            <el-table size="small" :data="form.zf"   border style="width: 100%" v-loading="loading">
          <el-table-column prop="name" label="条目"></el-table-column>

          <el-table-column prop="amount" label="金额">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.price"
                @input="updatezfPrice(scope.row)"
                placeholder="请输入金额"
                type="number"
              ></el-input>
            </template>

          </el-table-column>
          <el-table-column prop="note" label="备注">

            <template slot-scope="scope">
              <el-input
                v-model="scope.row.note"
  
                placeholder="请输入备注"
                type="text"
              ></el-input>
            </template>

          </el-table-column>
      
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="delZf(scope.$index)" size="mini">删除</el-button>
            </template>
          </el-table-column>


          <!-- 自定义插入一行 -->
          <template v-slot:append>
            
            <div style="float: right;">
                <tr class="custom-footer" style="border: 1px solid red;">
                <!-- 合并列 --> 
              
                  <td style="width: 100px;float: right;line-height: 50px; text-align: center; background-color: #f5f5f5;">
                    {{ form.zfTotalAmount }}
                  </td>
                  <td  style="width: 100px;float: right;line-height: 50px; text-align: center; font-weight: bold; background-color: #f5f5f5;">
                    总计
                  </td>
                  <div style="clear: both;"></div>
              
              </tr>
            </div>
  
          </template>
        </el-table>

        <div class="common-form">入库单</div>   

        <div class="draggable-list">
        <draggable class="wrapper" v-model="form.images">
          <transition-group>
            <div v-for="(item, index) in form.images" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'images')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('images')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
   
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
  <Product :isproduct="isproduct" :supply_id="form.supply_id" :excludeIds="excludeIds" :islist="islist" @closeDialog="closeDialogFunc"></Product>
</el-dialog>
  
</template>

<script>
import Warehouse_managementApi from '@/api/warehouse_management.js';
import Product from '@/components/product/SkuProductz';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import {mergeTable} from '@/utils/table.js'
import Supply from '@/components/supply/supply_common_rk.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter,
     Product,
     Supply
  },
  data() {
    return {
      isproduct: false,
      /*产品去重*/
      excludeIds: [],
      islist:true,
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        type:1,
        product:[],
        totalAmount:0,
        actualAmount:0,
        zfTotalAmount:0,
        zf:[],
        supply_id:0,
        supply:{},
        images:[]

      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入入库管理名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      selectType:'1',
      warehouse:[],
      activeStep: 4, // 当前步骤
      set_num:0,
      warehouse_kw_id:0,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;

  },
  props: ["open_add"],
  computed: {


},
  methods: {
      /*全部应用*/
      allApply() {
      let arr = [];
      for (let i = 0; i < this.form.product.length; i++) {
        let item = this.form.product[i];
  
        item.set_num = this.set_num;
        item.warehouse_kw_id = this.warehouse_kw_id
        this.updateAmount(item);
      }
    },
    closeDialogs(){
      this.getWarehouse()
    },
    getWarehouse(){
      var self = this;
      var parmas = {};
      if(self.form.type == 1){
        parmas = {
          supply_id: this.form.supply_id,
        }
      }
      Warehouse_managementApi.getWarehousex(parmas, true)
            .then(data => {
              self.loading = false;
              console.log('data.data',data.data);
              self.warehouse = data.data;
            })
            .catch(error => {
              self.loading = false;
            });
    },
    // 更新金额（当修改单价时）
    updateAmount(row) {
      row.amount = (row.product_price * row.set_num).toFixed(2);
      this.updateTotalAmount();  // 更新总金额
    },
    // 更新单价（当修改总价时）
    updateUnitPrice(row) {
      if (row.set_num !== 0) {
        row.product_price =  row.amount / row.set_num;
      }
      this.updateTotalAmount();  // 更新总金额
    },
    // 更新总金额
    updateTotalAmount() {
      this.form.totalAmount = this.form.product.reduce((acc, row) => parseFloat(acc) + parseFloat(row.amount), 0);
      this.form.actualAmount = this.form.totalAmount
      this.$forceUpdate()
    },
    updatezfPrice(row) {

      this.form.zfTotalAmount = this.form.zf.reduce((acc, row) => parseFloat(acc) + parseFloat(row.price), 0);
      this.$forceUpdate()
    },
    del(index){
      this.form.product.splice(index,1)
    },
 
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    addZf(selectType){
      console.log(selectType);
      this.form.zf.push({
        'name':selectType==1?'采购支出':'杂费支出',
        'price':"",
        'note':""
      })
    },
    delZf(index){
      this.form.zf.splice(index,1)
    },

      /*关闭弹窗*/
    /*关闭弹窗*/
    closeDialogFunc(e) {
      console.log('e.params',e.params)
      let self = this;



      self.isproduct = false;
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            product_name: item.product_name,
            product_id: item.product_id,
            product_sku_id: item.product_sku_id,
            product_price: item.product_price,
            product_image: item.product_image,
            ck_warehouse_kw_id:item.warehouse_kw_id,
            warehousekwtext: item.warehousekwtext,
            warehousetext: item.warehousetext,
            unit: item.unit,
            spec_value:item.spec_value,
            status:0,//0 未入库 1  已入库
            set_num:1,
            file_path:item.image.file_path,
            rk:item.warehouse_management,
            category_name:item.category_name,
          };
          arr.push(obj)
        }
        self.form.product = self.form.product.concat(arr);
        self.form.product = mergeTable(this.form.product);
        for(var i=0;i<arr.length;i++){
          self.updateAmount(arr[i]);
        }

      
      
      }
    },
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_sku_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },


    onSubmit() {
      let self = this;
      let form = self.form;
      var product = self.form.product;
      var ind = 0;
      for(var i=0;i<product.length;i++){
          if(product[i].warehouse_kw_id == '0' || !product[i].warehouse_kw_id){
              ind++;
          }
      }
      if(ind > 0){
          self.$message({
            message: '请选择库位',
            type: 'error'
          });
        return false;
      }             
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Warehouse_managementApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      console.log('this.code ',this.code );
      console.log('e ',e );
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.images.concat(e);
        console.log('imgs',imgs)
        this.$set(this.form, "images", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'images'){
        this.form.images.splice(index, 1);
      }
      
    },

  }
};
</script>

<style>
.process-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.button-container {
  margin-top: 20px;
  text-align: center;
}
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}





</style>



// WEBPACK FOOTER //
// src/views/plus/warehouse_management/index/part/add.vue